function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { BadgeListEntry } from '../../molecules';
import { CallToAction, Container, EntryAnimation, Heading } from '../../atoms';
import { useAccentColors } from '../../hooks';
import { LightArrowRight } from '../../visuals';
export default function BadgeListEntriesGridSection(param) {
    var title = param.title, action = param.action, cards = param.cards, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? '--colors-purple-700' : _param_accentColor, className = param.className;
    var containerRef = useRef(null);
    var accentStyle = useAccentColors([
        'colors-badge-card-grid-section-bg',
        accentColor
    ], [
        'colors-button-main-bg-base',
        '--colors-neutral-900'
    ], [
        'colors-button-main-bg-hover',
        '--colors-neutral-900'
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        style: accentStyle,
        name: BadgeListEntriesGridSection.name,
        background: "custom",
        className: twMerge('py-6 bg-[var(--colors-badge-card-grid-section-bg)] md:py-11', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-7 grid-cols-1 grid-areas-[title,cards,action] md:grid-cols-[1fr_auto] md:grid-areas-[title_action,cards_cards]"
    }, !!title && /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[title] text-fg-inverted"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title)), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[action] my-auto"
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        className: "[&>button]:bg-button-main-bg-base/30 [&>button]:border-transparent w-full"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[cards] grid gap-7 grid-cols-1 grid-flow-row auto-rows-max sm:gap-10 md:gap-7 md:grid-cols-3"
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.title),
            view: containerRef,
            delay: (cardIndex + 1) / 5
        }, /*#__PURE__*/ React.createElement(BadgeListEntry, _object_spread_props(_object_spread({}, card), {
            accentColor: accentColor,
            variant: "inverted"
        })));
    }))));
}

//# sourceMappingURL=BadgeListEntriesGridSection.js.map